import { ComponentPropsWithoutRef, FC } from 'react';

export const ProfileHeightSmIcon: FC<ComponentPropsWithoutRef<'svg'>> = (props) => (
  <svg width="256" height="400" viewBox="0 0 256 400" fill="none" {...props}>
    <g clipPath="url(#clip0_3109_67919)">
      <path
        d="M125.452 364.152C74.948 364.152 34 323.169 34 272.622C34 222.076 74.948 181.084 125.452 181.084"
        fill="#FF5353"
      />
      <path
        d="M53.4771 216.154C66.1601 243.336 93.5838 262.244 125.461 262.583V181.084C96.2447 181.084 70.2202 194.803 53.4771 216.145V216.154Z"
        fill="#F2F7F7"
      />
      <path d="M176.029 325.915H153.781V391.461H176.029V325.915Z" fill="black" />
      <path d="M176.824 388.487L164.9 400H196.21L185.246 388.487H176.824Z" fill="#FF5353" />
      <path d="M153.781 365.854V388.862L164.9 400L177.602 389.695L153.781 365.854Z" fill="#FF5353" />
      <path d="M162.623 386.153H153.781V400H162.623V386.153Z" fill="#FF5353" />
      <path d="M153.781 379.06V390.564H187.185L176.221 379.06H153.781Z" fill="#FF5353" />
      <path d="M124.053 391.461H146.301V325.914H124.053V391.461Z" fill="black" />
      <path d="M123.248 388.487L135.172 400H103.862L114.826 388.487H123.248Z" fill="#FF5353" />
      <path d="M146.301 365.854V388.862L135.172 400L122.48 389.695L146.301 365.854Z" fill="#FF5353" />
      <path d="M137.449 399.991H146.292V386.144H137.449V399.991Z" fill="#FF5353" />
      <path
        d="M145.679 329.319H153.506C171.612 329.319 186.307 344.026 186.307 362.147V373.551H112.878V362.147C112.878 344.026 127.573 329.319 145.679 329.319Z"
        fill="black"
      />
      <path d="M146.301 379.06V390.564H112.888L123.852 379.06H146.301Z" fill="#FF5353" />
      <path
        d="M200.252 307.391C200.252 279.637 177.772 257.137 150.041 257.137C122.31 257.137 99.8296 279.637 99.8296 307.391V308.114C99.8296 335.868 122.31 358.368 150.041 358.368C177.772 358.368 200.252 335.868 200.252 308.114V307.391Z"
        fill="black"
      />
      <path
        d="M113.765 342.864C122.909 352.418 135.775 358.376 150.04 358.376C164.305 358.376 177.171 352.428 186.316 342.864H113.765Z"
        fill="black"
      />
      <path
        d="M150.04 257.137C144.325 257.137 138.83 258.098 133.7 259.855V364.747H166.372V259.855C161.251 258.089 155.756 257.137 150.031 257.137H150.04Z"
        fill="#B3E0DF"
      />
      <path
        d="M109.102 278.91C109.102 256.286 127.427 237.945 150.031 237.945C172.636 237.945 190.961 256.286 190.961 278.91"
        fill="#B3E0DF"
      />
      <path d="M190.964 288.351L150.034 247.387L109.105 288.351L150.034 329.316L190.964 288.351Z" fill="#B3E0DF" />
      <path
        d="M150.214 193.238V144H156.085C183.015 144 204.842 165.846 204.842 192.799L150.214 193.238Z"
        fill="#E2231A"
      />
      <path
        d="M171.923 192.799V253.348H166.052C139.141 253.348 117.295 231.484 117.295 204.55V144H123.166C150.077 144 171.923 165.864 171.923 192.799Z"
        fill="#FF5353"
      />
      <path
        d="M185.548 203.589H130.929V275.231C130.929 286.094 139.726 294.898 150.58 294.898C161.434 294.898 170.231 286.094 170.231 275.231V271.735H170.268C170.268 262.473 176.824 254.739 185.539 252.937V203.589H185.548Z"
        fill="#E2231A"
      />
      <path
        d="M162.779 193.238V192.798C162.779 172.042 146.758 154.955 126.439 153.289V193.238H162.779Z"
        fill="#E2231A"
      />
      <path
        d="M185.548 193.238H130.929V264.88C130.929 275.743 139.726 284.547 150.58 284.547C161.434 284.547 170.231 275.743 170.231 264.88V261.384H170.268C170.268 252.122 176.824 244.388 185.539 242.585V193.238H185.548Z"
        fill="#FF5353"
      />
      <path
        d="M171.228 253.348C193.954 253.348 212.377 234.909 212.377 212.164C212.377 189.419 193.954 170.98 171.228 170.98C148.502 170.98 130.079 189.419 130.079 212.164C130.079 234.909 148.502 253.348 171.228 253.348Z"
        fill="#FF5353"
      />
      <path
        d="M162.129 211.826C162.129 207.277 165.815 203.589 170.359 203.589C174.904 203.589 178.589 207.277 178.589 211.826"
        fill="black"
      />
      <path
        d="M185.548 222.515H144.307C144.307 240.92 156.432 256.487 173.13 261.658C175.855 257.247 180.308 254.026 185.548 252.936V222.515Z"
        fill="#E2231A"
      />
      <path
        d="M221 212.164C221 234.907 202.574 253.348 179.851 253.348C157.127 253.348 138.702 234.907 138.702 212.164"
        fill="#FF5353"
      />
      <path
        d="M221 212.164C221 216.713 217.315 220.401 212.77 220.401C208.226 220.401 204.541 216.713 204.541 212.164"
        fill="#E2231A"
      />
      <path
        d="M187.98 211.826C187.98 207.277 191.665 203.589 196.21 203.589C200.755 203.589 204.44 207.277 204.44 211.826"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_3109_67919">
        <rect width="187" height="256" fill="white" transform="translate(34 144)" />
      </clipPath>
    </defs>
  </svg>
);
